import { Button } from '../../../components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '../../../components/ui/dialog'
import { Textarea } from '../../../components/ui/textarea'

/** One textarea and a confirm button: rejections, acknowledgements, rebuild notes. */
export function NoteDialog({
  open,
  onOpenChange,
  title,
  description,
  note,
  onNoteChange,
  actionLabel,
  required = false,
  destructive = false,
  loading,
  error,
  onSubmit
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  note: string
  onNoteChange: (note: string) => void
  actionLabel: string
  required?: boolean
  /** The confirm button is red: the action drops something that can't be brought back. */
  destructive?: boolean
  loading: boolean
  error?: string
  onSubmit: () => void
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <Textarea
          value={note}
          onChange={(event) => onNoteChange(event.target.value)}
          placeholder={required ? 'Reason (required)' : 'Optional note'}
        />
        {error ? <p className="text-sm text-st-down">{error}</p> : null}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant={destructive ? 'destructive' : 'default'}
            disabled={loading || (required && !note.trim())}
            onClick={onSubmit}
          >
            {actionLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
